<template>
    <div class="biometrics-create mb-3 mt-page">

        <data-form
                   :title="$i18n.gt('HEADING_ADD_BIOMETRICS')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="biometricsFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_BIOMETRICS_CREATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_CREATING_BIOMETRICS')"
                   :submit-success-route="`/biometrics/practiceId/${practiceId}`"
                   :cancel-route="`/biometrics/practiceId/${practiceId}`">
        </data-form>

    </div>
</template>

<script>

    import Vue from 'vue'
    import * as _ from 'lodash'
    import BiometricsFields from '../models/Biometrics'

    /**
     * Page for practitioner to create a Biometrics record
     */
    export default Vue.extend({
        name: 'BiometricsCreate',
        props: {
            practiceId: Number,
        },
        data () {
            return {
                biometricsFields: BiometricsFields,
                fieldGroups: [
                    ['participant_id', 'external_id', 'comment'],
                    ['tchol', 'ldl_c', 'hdl_c', 'trig', 'fasting_bg', 'a1c'],
                ]
            }
        },
        methods: {
            loadModelInstance () {
                return new Promise((resolve, reject) => {
                    const biometrics = {
                        practice_id: this.$user.practitionerPracticeId()
                    }
                    resolve(biometrics)
                })
            },
            onSubmit (modelInstance) {
                return this.$api.createItem(this, 'biometrics', modelInstance)
            },
        }
    })

</script>
